import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage } from 'firebase/messaging';

const firebaseConfig = {
	apiKey: "AIzaSyCs1Al6AeZMXqH08rC_tj17934AAuJyfOU",
	authDomain: "digiit-7d5dc.firebaseapp.com",
	projectId: "digiit-7d5dc",
	storageBucket: "digiit-7d5dc.appspot.com",
	messagingSenderId: "764866981920",
	appId: "1:764866981920:web:b5d91afc80dd9854268c45",
	measurementId: "G-34VQ429FRL"
};
const firebaseApp = initializeApp(firebaseConfig);
export const messaging = getMessaging(firebaseApp);

export const getOrRegisterServiceWorker = () => {
	if ('serviceWorker' in navigator) {
		return window.navigator.serviceWorker
			.getRegistration('/firebase-push-notification-scope')
			.then((serviceWorker) => {
				if (serviceWorker) return serviceWorker;
				return window.navigator.serviceWorker.register('/firebase-messaging-sw.js', {
					scope: '/firebase-push-notification-scope',
				});
			});
	}
	throw new Error('The browser doesn`t support service worker.');
};

export const getFirebaseToken = () =>
	getOrRegisterServiceWorker()
		.then((serviceWorkerRegistration) =>
			getToken(messaging, { vapidKey: "BOJyFzCiHX3d_sf3ZOTUkJZjOhf1VJ9PooKGg7isyPOWWfNcIOfd_VQ0WUJ2WZnhne0kGF1eHFh_dEApFIggtOw", serviceWorkerRegistration }));

export const onForegroundMessage = () => {
	return new Promise((resolve) => onMessage(messaging, (payload) => {
		resolve(payload)
	}))
}
